import React, {Component} from 'react';
import {Form, Popover} from 'antd';
import DescriptionList from '@comm/DescriptionList';
import {Link} from 'react-router';
import moment from 'moment';
import util from '@util/index';
import {queryInvoiceType} from '@api/core/dict';
import {queryInvoiceList} from '@api/incubator/invoice';
import {BackBtn} from '@comm/BackBtn';
import TableInvoice from './TableInvoice';

const { Description } = DescriptionList;
class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceType: {},
    };
  }

  componentDidMount() {
    this.getInvoiceType();
    this.loadData();
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  getInvoiceList = params => {
    queryInvoiceList(params).then(res => {});
  };

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        const invoiceType = {};
        res.data.forEach(item => {
          invoiceType[item.value] = item.key;
        });
        this.setState({
          invoiceType,
        });
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
      ...this.sorter,
      customUuid: this.props.params.customUuid,
      incubatorUuid: this.props.params.uuid,
    };
    this.getInvoiceList(params);
  };

  columns = () => {
    const getContent = content => (
      <div style={{ width: '300px' }}>
        <DescriptionList size="large" col={1}>
          <Description term="作废原因">{content.invalidReason}</Description>
          <Description term="操作人员">{content.invalidUser}</Description>
          <Description term="操作时间">
            {content.invalidDate
              ? moment.unix(content.invalidDate / 1000).format('YYYY-MM-DD')
              : null}
          </Description>
        </DescriptionList>
      </div>
    );
    const { invoiceType } = this.state;
    return [
      {
        title: '开票编号',
        dataIndex: 'no',
        width: 150,
        render: (text, record) => (
          <Link to={`/incubator/invoice_manage/open/${record.uuid}`}>{text}</Link>
        ),
      },
      {
        title: '客户',
        dataIndex: 'custom',
        key: 'custom',
        width: 150,
        render: (text, record) => (
          <span>
            {record.custom}
            {record.projectName ? `(${record.projectName})` : ''}
          </span>
        ),
      },
      {
        title: '收款公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '开票类型',
        dataIndex: 'type',
        key: 'type',
        render: text => <span>{invoiceType[text]}</span>,
      },
      {
        title: '开票金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 150,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          if (record.instance && record.instance.status === 1) {
            return <span style={{ color: 'red' }}>已完成</span>;
          }
          return <span>处理中</span>;
        },
      },
      {
        title: '作废情况',
        dataIndex: 'invalid',
        render: (text, record) => (
          <span>
            {record.invalid ? (
              <Popover content={getContent(record)} title="作废详情">
                已作废
              </Popover>
            ) : (
              ''
            )}
          </span>
        ),
      },
    ];
  };

  render() {
    const {
      params: { customUuid, uuid },
    } = this.props;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <TableInvoice customUuid={customUuid} incubatorUuid={uuid} pageSize={15} />
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/PageCustomInvoice.js